import { TableColumn } from '@maersk-global/mds-components-core/mc-table/types';
import { utils } from '../../../helper/utils';
import { MaintenanceOrderHeader } from '../../../models/maintenance-order-header.model';

export const workOrderListGridColumns: Array<TableColumn> = [
  {
    id: 'maintenanceOrderNumber',
    label: 'Work Order Number',
    sortDisabled: true,
  },
  {
    id: 'equipmentNumber',
    label: 'Equipment Number',
    sortDisabled: true,
  },
  {
    id: 'totalOrderCostUSD',
    label: 'Total Value(USD)',
    dataType: {
      type: 'number',
      formatter: (value, row) => {
        return utils.numberFormatter.format(Number(value));
      },
    },
  },
  {
    id: 'totalOrderCost',
    label: 'Total Value(Shop Currency)',
    sortDisabled: true,
    dataType: {
      type: 'number',
      formatter: (value, row) => {
        return `${(row.original as MaintenanceOrderHeader).isoCurrencyCode} ${utils.numberFormatter.format(Number(value))}`;
      },
    },
  },
  {
    id: 'maintenanceRepairModeCode',
    label: 'Mode',
    sortDisabled: true,
  },
  {
    id: 'maintenanceOrderStatusName',
    label: 'Status',
    sortDisabled: true,
  },
  {
    id: 'maintenanceOrderStatusDuration',
    label: 'Status Duration',
    dataType: {
      type: 'string',
      formatter: (cellValue: unknown) => utils.formatDuration(cellValue as number),
    },
  },
  {
    id: 'createTimestamp',
    label: 'Created On',
    dataType: {
      type: 'string',
      formatter: (value) => {
        const date = new Date(value as string);
        return `${utils.dateFormatter.format(date)}`;
      },
    },
  },
  {
    id: 'createUserID',
    label: 'Created By',
    sortDisabled: true,
  },
  {
    id: 'maintenanceShopCode',
    label: 'Shop ID',
    sortDisabled: true,
  },
  {
    id: 'locationCode',
    label: 'Location',
    sortDisabled: true,
  },
  {
    id: 'updateTimestamp',
    label: 'Last Updated On',
    dataType: {
      type: 'string',
      formatter: (value) => {
        const stringValue = value as string;
        const date = new Date(stringValue);
        return stringValue && date ? utils.dateFormatter.format(date) : '';
      },
    },
  },
  {
    id: 'purchaseOrderNumber',
    label: 'PO Number',
    sortDisabled: true,
  },
];
